import { useTitle } from 'react-use';

import { Layout } from 'CorePackage/MainModule/components/Layout';

import { NewsForm } from './NewsForm';

export const NewsFormPage = () => {
  useTitle('Форма новостей');

  return (
    <Layout withFooter>
      <NewsForm />
    </Layout>
  );
};
